import './PurchasePrices.scss';
import PageLayout from '../../wrappers/PageLayout';
import { Loader } from '../../components/Loader/Loader';
import PurchasePricesUploader from './PurchasePricesUploader';
import { ReactComponent as PPIcon } from '../../icons/purchase-prices.svg';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../components/Modal/useModal';
import PurchasePricesFAQModal from './PurchasePricesFAQModal';
import { usePP } from '../../context/pp-context';
import Button from '../../components/Button';

export default function PurchasePrices() {
  const { t } = useTranslation();
  const { isLoadingPP } = usePP();
  const { isModalOpened, closeModal, openModal } = useModal();

  if (isLoadingPP) return <Loader />;

  return (
    <>
      <PageLayout
        className='flex-grow-1'
        rightColumn={
          <div style={{ maxWidth: 328 }} className='ms-lg-auto pt-3 pt-lg-0'>
            <div className='Paper mb-3 d-flex flex-column align-items-center justify-content-center py-4 px-3'>
              <PPIcon />
              <div className='mt-3 Text--20 fw-800 mb-3 text-center'>
                {t('What is Purchase Price and why it is required')}
              </div>
              <Button className='mb-2' onClick={openModal} styling='outline'>
                {t('Open FAQ')}
              </Button>
            </div>
          </div>
        }
      >
        <PurchasePricesUploader />
      </PageLayout>
      <PurchasePricesFAQModal
        isModalOpened={isModalOpened}
        closeModal={closeModal}
      />
    </>
  );
}
